module.exports = __webpack_public_path__ + "img/noti-success2.5a750319.svg";